import type { Translations } from "../types";

const sr: Translations = {
  "meta.title": "Кликови по државама на мапи",
  "meta.description":
    "Интерактивна мапа света: бесплатни кликови по држави плус плаћена подршка преко Stripe-а, PayPal-а и Buy Me a Coffee-а.",

  "app.title": "Кликови по државама на мапи",

  "map.intro":
    "Кликни на државу на мапи да јој даш бесплатан глас, или јој пошаљи финансијску подршку - обоје се рачуна за заједничку ранг-листу испод. Мапа одражава само подршку унутар ове апликације, а не стварно национално богатство или БДП.",
  "map.verifying": "Провера у току …",
  "map.confirmNotRobot": "Пре него што можеш да додајеш бесплатне кликове, брзо потврди да ниси робот:",
  "map.tryAgain": "Покушај поново",
  "map.registeringClick": "Региструје се клик …",
  "map.selectedCountry": "Изабрана држава: {name}.",
  "map.selectFirstFeedback": "Држава је изабрана. Да би додао бесплатан клик, прво потврди испод да ниси робот.",
  "map.verificationExpired": "Потврда је истекла - потврди поново да ниси робот.",
  "map.slowDown": "Мало спорије - сачекај тренутак пре следећег клика.",
  "map.clickFailed": "Клик није могао да се региструје. Покушај поново.",
  "map.clickErrorGeneric": "Грешка при регистровању клика.",
  "map.leaderboardHeading": "Ранг-листа држава",
  "map.emptySelection": "Изабери државу на мапи да јој даш клик или је подржиш.",
  "map.loadingData": "Учитавање података …",

  "worldmap.loadError": "Мапу није било могуће учитати.",
  "worldmap.resetZoom": "Ресетуј зум",
  "worldmap.resetButton": "⤾ Ресетуј",
  "worldmap.loadingMap": "Учитавање мапе …",
  "worldmap.unknownCountry": "Непознато",
  "worldmap.ariaClicks": "{name}: {clicks} кликова",
  "worldmap.tooltipClicks": "{clicks} кликова",

  "legend.fewer": "Мање кликова",
  "legend.more": "Више кликова",

  "list.empty": "Још увек нема кликова. Буди први!",
  "list.ariaLabel": "Ранг-листа држава по кликовима",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY није подешен - погледај README за конфигурацију.",
  "human.verificationFailedGeneric": "Провера није успела.",
  "human.networkError":
    "Провера није доступна (грешка у мрежи) - провери VITE_SUPABASE_URL, да ли је verify-human објављен, и ALLOWED_ORIGIN; погледај README/NAVODILA.",
  "human.verificationFailedRetry": "Провера није успела, покушај поново.",

  "provider.stripe": "💳 Картица (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Изабрана држава",
  "panel.currentlyRanked": "Тренутно на #{rank}. месту",
  "panel.shareCopied": "Копирано ✓",
  "panel.shareShared": "Подељено ✓",
  "panel.shareButton": "🔗 Подели",

  "panel.tableClicks": "Кликови",
  "panel.tableFree": "Бесплатно",
  "panel.tablePaid": "Плаћено",
  "panel.rowAllTime": "Укупно",
  "panel.rowThisYear": "Ове године",
  "panel.rowThisWeek": "Ове недеље",
  "panel.rowToday": "Данас",

  "panel.totalCombined": "Укупно комбиновано:",
  "panel.totalSupport": "Укупна подршка:",

  "panel.paymentMethod": "Начин плаћања",
  "panel.noPaymentMethod": "Тренутно није доступан ниједан начин плаћања.",
  "panel.supportAmount": "Износ подршке (EUR)",
  "panel.amountRange": "Износ треба да буде између {min} и {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Процењени плаћени кликови:",
  "panel.ratioInfo":
    "Однос: {a} = {b} кликова (нпр. {c} = {d} кликова). Ово је само процена пре плаћања - коначан број кликова увек израчунава и потврђује сервер на основу стварно потврђене уплате.",
  "panel.preparing": "Припрема …",
  "panel.continueWith": "Настави са {provider}",
  "panel.choosePaymentMethod": "Изабери начин плаћања",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME није подешен - погледај README за конфигурацију.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID није подешен - погледај README за конфигурацију.",

  "panel.paypalAmountInfo": "Износ: {amount} (процењено {clicks} кликова). Заврши плаћање помоћу PayPal дугмета испод.",
  "panel.back": "← Назад",

  "panel.bmcWarningTitle": "⚠️ Пре него што наставиш на BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Налепи код испод у поље за поруку/напомену приликом плаћања — то је једини начин на који ћемо знати коју државу подржаваш. Без кода не можемо да повежемо уплату ни са једном државом.",
  "panel.copy": "Копирај",
  "panel.copied": "Копирано ✓",
  "panel.suggestedAmount": "Предложени износ:",
  "panel.bmcAmountNote":
    "(процењено {clicks} кликова). BuyMeCoffee нажалост не подржава преношење износа путем линка — унеси/изабери га сам на њиховом сајту. Стварни број кликова увек се израчунава на основу износа који стварно пошаљеш на BuyMeCoffee-у, а не на основу ове процене.",
  "panel.openBmc": "Отвори BuyMeCoffee и настави →",
  "panel.waitingProvider": "Чека се потврда плаћања од добављача услуге …",
  "panel.waitingConfirmation": "Чека се потврда плаћања …",
  "panel.timedOut":
    "Провера је истекла. Ако си завршио плаћање, мапа ће се ажурирати чим сервер прими потврду - то понекад може мало дуже да потраје.",
  "panel.checkAgain": "Провери поново",

  "panel.cancelled": "Плаћање је отказано или није прошло. Мапа се није променила.",
  "panel.tryAgain": "Покушај поново",

  "panel.confirmed": "✅ Подршка потврђена!",
  "panel.confirmedBody": "За {country} је забележено {clicks} плаћених кликова у износу од {amount}.",

  "panel.errorPreparingSupport": "Грешка при припреми твоје подршке.",
  "panel.errorPreparingPayment": "Грешка при припреми плаћања.",
  "panel.errorConfirmingPayment": "Грешка при потврђивању плаћања.",
  "panel.errorPayingPaypal": "Грешка при плаћању преко PayPal-а.",

  "share.unranked": "{flag}{country} треба твоју подршку на мапи света!\nПомози јој да се попне на ранг-листи 👇",
  "share.rank1": "{flag}{country} тренутно је на #1. месту!\nПомози нам да останемо на врху 👇",
  "share.rankN": "{flag}{country} тренутно је на #{rank}. месту!\nПомози нам да стигнемо до #1 👇",

  "language.switcherLabel": "Језик",
};

export default sr;
